import script from "./bomxq.vue?vue&type=script&setup=true&lang=js"
export * from "./bomxq.vue?vue&type=script&setup=true&lang=js"

import "./bomxq.vue?vue&type=style&index=0&id=1896141b&scoped=true&lang=scss"

import exportComponent from "D:\\liu\\jmzc\\jimuERPVUE\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1896141b"]])

export default __exports__